import "codemirror/mode/javascript/javascript";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/markdown-fold";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { UnControlled as CodeMirror } from "react-codemirror2";
import React from "react";

const DEFAULT_EDITOR_OPTIONS = {
    mode: { name: "javascript", json: true },
    theme: "material",
    foldGutter: true,
    gutters: ["CodeMirror-foldgutter"]
};

type EditableValueFieldProps = {
    value: unknown;
    onChange?: (value: unknown) => void;
    extraOptions?: any;
};

export const EditableValueField: React.FC<EditableValueFieldProps> = React.memo(({ value, onChange = null, extraOptions = {} }) => {
    const options = React.useMemo(() => ({ ...DEFAULT_EDITOR_OPTIONS, ...extraOptions }), [extraOptions]);
    const handleOnChange = React.useCallback((_editor, _data, value) => onChange && onChange(value), [onChange]);

    switch (typeof value) {
        default:
            return (
                <div className="code-container">
                    <CodeMirror
                        className="fill"
                        value={JSON.stringify(value, null, 2)}
                        options={options}
                        onChange={handleOnChange}
                    />
                </div>
            );
    }
});